export const acceptedFileTypesArray = ['image/jpg', 'image/jpeg'];
export const acceptedFileTypes = acceptedFileTypesArray.join(', ');
